const TAB_INDEX_FOCUSABLE = 0;
const TAB_INDEX_TEMPORARY_UNFOCUSABLE = -1;
const TAB_INDEX_NEVER_FOCUSABLE = -2;
export {
  TAB_INDEX_FOCUSABLE,
  TAB_INDEX_NEVER_FOCUSABLE,
  TAB_INDEX_TEMPORARY_UNFOCUSABLE
};
//# sourceMappingURL=Types.js.map
